<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('tv_code.update_title') }}</span>
            <span v-else>{{ $t('tv_code.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary" />
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('url')">
          <label>{{ $t('tv_code.url') }}</label>
          <b-form-select type="text" :placeholder="$t('tv_code.placeholders.url')" :options="options"
            :class="{ 'is-invalid': fErr('url') }" v-model="entity.url" />
        </b-form-group>
        <b-form-checkbox v-model="entity.is_used">
          {{ $dt('tv_code.is_used', 'Is used (not availble for login)') }}
        </b-form-checkbox>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small />
          {{ $t('global.save') }}
        </b-button>
        <b-button :to="{ name: 'TvCodes' }" variant="info" class="ml-2">
          {{ $dt('global.cancel-back', 'Cancel/Back') }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';
import VT from '@/store/types';
// import { mapGetters, mapActions } from 'vuex';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
      options: [
        '/dash/allprojectgant',
        '/dash/main',
        '/dash/billable',
        '/dash/allprojectworklogs',
        '/dash/BlackWall'
      ]
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          url: '',
          is_used: false,
        };
      },
    },
  },
  components: {
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
  },
  methods: {
    // ...mapActions('Auth', [VT.LOAD_USER_INFO]),
    getForUpdate: Services.tv_codes.editData,
    getForCreate: Services.tv_codes.createData,
    pushUpdate: Services.tv_codes.update,
    pushCreate: Services.tv_codes.create,
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.entity : { ...this.entity, ...data.data.entity };
        this.$refs.tagList.getData();
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.entity).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          // After successful create
          // if (this.$can('edit', 'tv_codes')) {
          // this.$router.push({ name: 'TvCodeUpdate', params: { id: data.data.id } });
          this.$router.push({ name: 'TvCodes' });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
      }).catch((data) => {
        this.spinners.isSaving = false;
        this.errorMsg = data.errors || {};
        console.log(data);
      });
    },
  }
};
</script>

<style scoped>

</style>
